@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/index-cards-3x5/stiiizy-strain-index-card-stack-content/stiiizy-strain-index-card-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  width: 100%;
  height: 100%;
  flex-wrap: nowrap;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.25rem;
  --badge-grid-min-col: 1rem;
}
:host .main-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  flex: 1 0 0;
  align-self: stretch;
}
:host .main-content .background-content {
  position: absolute;
  inset: 0;
  z-index: -1;
}
:host .main-content .background-content .print-card-background-asset {
  height: 100%;
  width: 100%;
}
:host .main-content .top-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  height: 10rem;
  width: 100%;
}
:host .main-content .top-content .brand-logo {
  width: 10rem;
}
:host .main-content .bottom-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  align-self: stretch;
}
:host .main-content .bottom-content .product-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.375rem;
  align-self: stretch;
}
:host .main-content .bottom-content .product-info .title-quantity-and-unit-size {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;
  align-self: stretch;
}
:host .main-content .bottom-content .product-info .title-quantity-and-unit-size .product-card-title {
  font-family: Archivo, sans-serif;
  font-weight: 900;
  font-size: 1.25rem;
}
:host .main-content .bottom-content .product-info .title-quantity-and-unit-size .product-card-size-and-label {
  font-family: Archivo, sans-serif;
  font-weight: 700;
  font-size: 0.75rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
}
:host .main-content .bottom-content .product-info .title-quantity-and-unit-size .product-card-size-and-label ::ng-deep .product-label {
  font-family: Archivo, sans-serif;
  font-weight: 600;
  font-size: 0.5625rem;
  margin-left: 0;
  padding: 0.125rem;
  border-radius: 0.125rem;
}
:host .main-content .bottom-content .product-info .pricing-container {
  position: relative;
}
:host .main-content .bottom-content .product-info .pricing-container .badge-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  transform: translate(calc(-100% - 0.5rem), 0);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0.25rem;
  justify-content: center;
  align-items: center;
}
:host .main-content .bottom-content .product-info .pricing-container .badge-container .badge {
  height: 1rem;
}
:host .main-content .bottom-content .product-info .pricing-container ::ng-deep .product-variant-price {
  position: relative;
  font-family: Archivo, sans-serif;
  font-weight: 800;
  font-size: 1.5rem;
  letter-spacing: -0.42px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
  line-height: 100%;
  overflow: visible;
}
:host .main-content .bottom-content .product-info .pricing-container ::ng-deep .product-variant-price .product-variant-previous-price {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(calc(100% + 0.5rem), 25%);
  font-family: Archivo, sans-serif;
  font-weight: 800;
  font-size: 1rem;
  letter-spacing: -0.21px;
  opacity: 0.5;
  line-height: 100%;
  overflow: visible;
}
:host .main-content .bottom-content .strain-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  align-self: stretch;
}
:host .main-content .bottom-content .strain-info .product-card-available-strains {
  font-family: Archivo, sans-serif;
  font-weight: 600;
  font-style: italic;
  font-size: 0.6875rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.375rem;
  align-self: stretch;
}
:host .main-content .bottom-content .strain-info .product-card-individual-product-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;
  align-self: stretch;
}
:host .main-content .bottom-content .strain-info .product-card-individual-product-info .product-card-variant-name {
  font-family: Archivo, sans-serif;
  font-weight: 900;
  font-size: 0.9375rem;
  letter-spacing: -0.45px;
}
:host .main-content .bottom-content .strain-info .product-card-individual-product-info .product-card-strain {
  font-family: Archivo, sans-serif;
  font-weight: 700;
  font-size: 0.75rem;
  letter-spacing: -0.36px;
}
:host .main-content .bottom-content .strain-info .plus-n-more-strains {
  font-family: Archivo, sans-serif;
  font-weight: 600;
  font-style: italic;
  font-size: 0.6875rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  align-self: stretch;
  letter-spacing: -0.11px;
}
/*# sourceMappingURL=stiiizy-strain-index-card-stack-content.component.css.map */
